import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { memo } from 'react';
import Icon from 'presentations/views/components/atoms/Icon';
import { black, gray02, primary } from 'presentations/views/styles/color';
import Skeleton from '../Skeleton';
import Link from 'presentations/views/components/atoms/Link';

interface Props {
  isLoading?: boolean;
  isConnect?: boolean;
  connectLink?: string;
  className?: string;
}

const Component = memo((props: Props) => {
  const t = translateInComponent(translations);
  if (props.isLoading) {
    return <Skeleton width={60} />;
  }
  return props.isConnect ? (
    <Container className={props.className}>
      <CheckIcon name="check-circle" />
      {props.connectLink ? (
        <ConnectedLink href={props.connectLink}>{t('isConnect')}</ConnectedLink>
      ) : (
        t('isConnect')
      )}
    </Container>
  ) : (
    <Container className={props.className}>
      <NotCheckIcon name="check-circle-outline" />
      {t('isNotConnect')}
    </Container>
  );
});
const Container = styled.div`
  display: flex;
  align-items: center;
  color: ${gray02};
`;
const CheckIcon = styled(Icon)`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  color: ${primary};
  margin-right: ${spacing(6)};
`;

const NotCheckIcon = styled(Icon)`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  color: ${gray02};
  margin-right: ${spacing(6)};
`;
const ConnectedLink = styled(Link)`
  color: ${black};
  font-weight: ${fontWeight('normal')};
`;

export default Component;
